import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'underscore'
import moment from 'moment'
import constants from '@/constants'

Vue.use(Vuex)

export default new Vuex.Store({

	state: {

		session: {
			profile: false,
			validated: false,
			values: {},
			section: {
				current: 0,
				completed: [],
				dynamic: false
			},
			inputs: {
				flagged: []
			},
			alerts: {
				current: 0,
				completed: [],
				dynamic: false
			},
			recommendation: 0,
			finished: false,
			aid: false,
			bridge: {
				active: null,
				step: null,
				question: 0,
				questions: [],
				code: null,
				errors: [],
				completed: []
			},
			patient: {
				mode: null,
				notes: '',
				goals: []
			}
		},

		data: {
			setup: {
				variables: {},
				composites: {},
				track: {
					enabled: 0,
					name: {
						input: '',
						recommendation: ''
					}
				},
				profile: {
					store: 0,
					firstname: 0,
					lastname: 0,
					id: 0
				},
				aid: {
					enabled: 0
				}
			},
			aid: {
				sections: []
			},
			form: {
				sections: [],
				inputs: {},
				alerts: {}
			},
			decision: {
				recommendations: {},
				blocks: {}
			},
			bridge: {
				actions: [],
				referral: {
					reasons: [],
					fields: []
				}
			},
			glossary: [],
			reference: {
				info: {}
			},
			pages: {
				head: {},
				home: {},
				homePatient: {},
				notfound: {},
				other: [],
				foot: {}
			}
		}

	},

	getters: {

		'data/setup/track': function(state) {

			return state.data.setup.track

		},

		'data/setup/profile/store': function(state) {

			return state.data.setup.profile.store

		},

		'data/setup/profile/firstname': function(state) {

			return state.data.setup.profile.firstname

		},

		'data/setup/profile/lastname': function(state) {

			return state.data.setup.profile.lastname

		},

		'data/setup/profile/id': function(state) {

			return state.data.setup.profile.id

		},

		'pages': function(state) {

			var isPatient = process.env.VUE_APP_MODE === 'patient'
			var pages = Object.assign({}, state.data.pages)

			if (isPatient && pages.homePatient && pages.homePatient.title) {
				pages.home = pages.homePatient
			}

			return pages

		},

		'logic/variable/friendly': function(state, getters) {

			return function(id) {
					
				var value = getters['logic/variable'](id)
				var variable = getters['data/setup/variables'][id]

				if (variable.type === constants.logic.variable.type.boolean) {

					value = (value) ? 'True' : 'False'

				} else if (variable.type === constants.logic.variable.type.option) {

					value = variable.values[value]

				}

				return value

			}

		},

		'logic/variable/named': function(state, getters) {

			var named = {}

			_.each(getters['data/setup/variables'], function(variable) {

				named[variable.reference] = variable.id

			})

			return named

		},

		'logic/variable': function(state, getters) {

			return function(id) {

				var value = getters['session/values'][id]
				var variable = getters['data/setup/variables'][id]
				var returnValue = value

				if (value === null) return null

				if (!variable) return value

				if (variable.type === constants.logic.variable.type.boolean) {

					returnValue = (value) ? 1 : 0

				} else if (variable.type === constants.logic.variable.type.number) {

					if (_.isString(value)) {

						if (value.indexOf('/') >= 0) {

							var parts = value.split('/')

							returnValue = moment().diff(parts[2] + '-' + parts[1] + '-' + parts[0], 'years', false)

						} else {

							returnValue = parseFloat(value)

						}

					} else if (_.isBoolean(value)) {

						returnValue = (value) ? 1 : 0

					} else {

						returnValue = value

					}

				} else {

					returnValue = value

				}

				return returnValue

			}

		},

		'logic/evaluate': function(state, getters) {

			return function(logic) {

				var result = 0
				var operand = _.keys(logic)[0]
				var conditions = logic[operand]
				var values = []

				_.each(conditions, function(condition) {

					var value

					if(_.isArray(condition)) {

						var input = condition[0];
						var comparison = parseInt(condition[1]);
						var target = parseFloat(condition[2])

						var dataValue;
						var dataReference = parseInt(input.substr(2))

						if (input.indexOf('c:') === 0) {

							dataValue = getters['logic/evaluate'](getters['data/setup/composites'][dataReference].logic)

						} else {

							dataValue = getters['logic/variable'](dataReference)

						}

						if (_.isNull(dataValue)) {

							if (comparison === constants.logic.comparison.equal) {

								if (target === -1) {

									value = 0

								} else if (target === -2) {

									value = 1

								} else {

									value = (!target) ? 1 : 0

								}

							} else {

								if (comparison === constants.logic.comparison.notequal && target === -1) {

									value = 1

								} else if (comparison === constants.logic.comparison.notequal && target === -2) {

									value = 0

								} else {

									value = (comparison === constants.logic.comparison.notequal && condition[2] !== "") ? 1 : 0

								}

							}

						} else {

							if (comparison === constants.logic.comparison.equal) {

								if (target === -1) {

									value = 1

								} else if (target === -2) {

									value = 0

								} else if (_.isArray(dataValue)) {

									value = _.contains(dataValue, target) || _.contains(dataValue, parseFloat(target)) ? 1 : 0

								} else {

									value = (parseFloat(dataValue) === parseFloat(target)) ? 1 : 0;

								}

							} else if(comparison === constants.logic.comparison.notequal) {

								if (target === -1) {

									value = 0

								} else if (target === -2) {

									value = 1

								} else if (_.isArray(dataValue)) {

									value = !_.contains(dataValue, target) && !_.contains(dataValue, parseFloat(target)) ? 1 : 0

								} else {

									value = (parseFloat(dataValue) !== parseFloat(target)) ? 1 : 0;

								}

							} else if(comparison === constants.logic.comparison.lessthan) {

								value = (parseFloat(dataValue) < parseFloat(target)) ? 1 : 0;

							} else if(comparison === constants.logic.comparison.morethan) {

								value = (parseFloat(dataValue) > parseFloat(target)) ? 1 : 0;

							} else if(comparison === constants.logic.comparison.lessthanorequal) {

								value = (parseFloat(dataValue) <= parseFloat(target)) ? 1 : 0;

							} else if(comparison === constants.logic.comparison.morethanorequal) {

								value = (parseFloat(dataValue) >= parseFloat(target)) ? 1 : 0;

							}

						}

						values.push(value);

					} else if(_.isObject(condition)) {

						value = getters['logic/evaluate'](condition);

						values.push(value);

					}

				})

				var totalValue = values.reduce(function add(a, b) {

					return a + b;

				}, 0);

				if(operand === constants.logic.operand.and){

					result = (totalValue === values.length) ? 1 : 0;

				} else if(operand === constants.logic.operand.or){

					result = (totalValue >= 1) ? 1 : 0;
					
				} else if(operand === constants.logic.operand.nand){

					result = (totalValue < values.length) ? 1 : 0;
					
				} else if(operand === constants.logic.operand.nor){

					result = (totalValue === 0) ? 1 : 0;
					
				}

				return result;

			}

		},

		'logic/required': function(state, getters) {

			return function(item, field) {

				field = field || 'required'

				if (item[field].enabled === constants.required.never) {

					return false

				} else if (item[field].enabled === constants.required.always) {

					return true

				} else {

					return getters['logic/evaluate'](item[field].logic)

				}

			}

		},

		'logic/visible': function(state, getters) {

			return function(item, field) {

				field = field || 'visibility'

				if (item[field].enabled === constants.visibility.required) {

					return getters['logic/required'](item)

				} else if (item[field].enabled === constants.visibility.always) {

					return true

				} else {

					return getters['logic/evaluate'](item[field].logic)

				}

			}

		},

		'session/validated': function(state) {

			return state.session.validated

		},

		'session/profile': function(state) {

			return state.session.profile

		},

		'session/values': function(state) {

			return state.session.values

		},

		'session/values/named': function(state, getters) {

			var named = {}

			_.each(getters['data/setup/variables'], function(variable) {

				if(variable.reference) named[variable.reference] = state.session.values[variable.id]

			})

			return named

		},

		'session/alerts/current': function(state) {

			return state.session.alerts.current

		},

		'session/alerts/dynamic': function(state) {

			return state.session.alerts.dynamic

		},

		'session/alerts/completed': function(state) {

			return state.session.alerts.completed

		},

		'session/inputs/flagged': function(state) {

			return state.session.inputs.flagged

		},

		'session/section/current': function(state) {

			return state.session.section.current

		},

		'session/section/completed': function(state) {

			return state.session.section.completed

		},

		'session/section/dynamic': function(state) {

			return state.session.section.dynamic

		},

		'session/section/current/inputs': function(state, getters) {

			var inputs = []
			var section = getters['data/form/sections/associated'][state.session.section.current]

			if (!section) return inputs

			_.each(section.layout, function(layout) {

				if (layout.type !== constants.layout.type.text) {

					_.each(layout.inputs, function(input) {

						inputs.push(getters['data/form/inputs'][input])

					})

				}

			})

			return inputs

		},

		'session/section/current/alerts': function(state, getters) {

			var alerts = []
			var section = getters['data/form/sections/associated'][state.session.section.current]

			if (!section) return alerts

			_.each(section.alerts, function(alert) {

				alerts.push(getters['data/form/alerts'][alert])

			})

			return alerts

		},

		'session/recommendation': function(state) {

			return state.session.recommendation

		},

		'session/finished': function(state) {

			return state.session.finished

		},

		'session/aid': function(state) {

			return state.session.aid

		},

		'data/aid/sections': function(state) {

			return state.data.aid.sections

		},

		'data/form/inputs': function(state) {

			return state.data.form.inputs

		},

		'data/form/alerts': function(state) {

			return state.data.form.alerts

		},

		'data/form/sections': function(state) {

			return state.data.form.sections

		},

		'data/form/sections/associated': function(state) {

			var sections = {}

			_.each(state.data.form.sections, function(section) {

				sections[section.id] = section

			})

			return sections

		},

		'data/setup': function(state) {

			return state.data.setup

		},

		'data/setup/composites': function(state) {

			return state.data.setup.composites

		},

		'data/setup/variables': function(state) {

			return state.data.setup.variables

		},

		'data/decision/recommendations': function(state) {

			return state.data.decision.recommendations

		},

		'data/decision/blocks': function(state) {

			return state.data.decision.blocks

		},

		'data/bridge/actions': function(state) {

			return state.data.bridge.actions

		},

		'data/bridge/referral': function(state) {

			return state.data.bridge.referral

		},

		'data/aid/sections/active': function(state) {

			var isPatient = process.env.VUE_APP_MODE === 'patient'

			var sections = _.filter(state.data.aid.sections, function(s) {
				if (isPatient) return s.patient && s.patient.visible >= 1 && !s.patient.parent
				return !s.patient || s.patient.visible <= 1
			})

			if (isPatient) {
				sections = _.sortBy(sections, function(s) {
					return (s.patient && s.patient.order) ? s.patient.order : 0
				})
			}

			return sections

		},

		// Top-level sections the patient can actually navigate between, mirroring
		// the side-nav: the entry/data-entry section is only shown in manual mode.
		// Clinician build is unaffected — it navigates the full active list.
		'data/aid/sections/navigable': function(state, getters) {

			if (process.env.VUE_APP_MODE !== 'patient') return getters['data/aid/sections/active']

			var mode = getters['session/patient/mode']

			return _.filter(getters['data/aid/sections/active'], function(s) {
				if (s.type === 'entry' && mode !== 'manual') return false
				return true
			})

		},

		'data/aid/sections/children': function(state) {

			return function(parentId) {

				return _.sortBy(_.filter(state.data.aid.sections, function(s) {
					return s.patient && s.patient.parent === parentId
				}), function(s) {
					return s.patient.order
				})

			}

		},

		'data/aid/sections/all': function(state) {

			var isPatient = process.env.VUE_APP_MODE === 'patient'

			var sections = _.filter(state.data.aid.sections, function(s) {
				if (isPatient) return s.patient && s.patient.visible >= 1
				return !s.patient || s.patient.visible <= 1
			})

			if (isPatient) {
				sections = _.sortBy(sections, function(s) {
					return (s.patient && s.patient.order) ? s.patient.order : 0
				})
			}

			return sections

		},

		'data/form/sections/patient': function(state) {

			return _.filter(state.data.form.sections, function(section) {
				return section.type === constants.section.type.patient
			})

		},

		'data/form/sections/patient/associated': function(state, getters) {

			var sections = {}

			_.each(getters['data/form/sections/patient'], function(section) {
				sections[section.id] = section
			})

			return sections

		},

		'data/glossary': function(state) {

			return state.data.glossary

		},

		'session/patient/mode': function(state) {

			return state.session.patient.mode

		},

		'data/form/sections/nextstep': function(state) {

			return _.filter(state.data.form.sections, function(section) {
				return section.type === constants.section.type.nextstep
			})

		},

		'data/form/sections/nextstep/associated': function(state, getters) {

			var sections = {}

			_.each(getters['data/form/sections/nextstep'], function(section) {
				sections[section.id] = section
			})

			return sections

		},

		'session/bridge': function(state) {

			return state.session.bridge

		},

		'session/bridge/active': function(state) {

			return state.session.bridge.active

		},

		'session/bridge/step': function(state) {

			return state.session.bridge.step

		},

		'session/bridge/code': function(state) {

			return state.session.bridge.code

		},

		'session/bridge/errors': function(state) {

			return state.session.bridge.errors

		},

		'session/bridge/completed': function(state) {

			return state.session.bridge.completed

		},

		'data/reference/info': function(state) {

			return state.data.reference.info

		}

	},

	mutations: {

		'session/reset': function(state) {

			state.session.profile = true

			state.session.values = {}

			state.session.section = {
				current: 0,
				completed: [],
				dynamic: false
			}

			state.session.inputs = {
				flagged: []
			}

			state.session.alerts = {
				current: 0,
				completed: [],
				dynamic: false
			}

			state.session.recommendation = 0

			state.session.finished = false
			state.session.aid = false

			state.session.bridge = {
				active: null,
				step: null,
				question: 0,
				questions: [],
				code: null,
				errors: [],
				completed: []
			}

			state.session.patient = {
				mode: null
			}

			_.each(state.data.setup.variables, function(variable, id) {

				Vue.set(state.session.values, id, null)

			})

			var isPatient = process.env.VUE_APP_MODE === 'patient'

			var firstSection = _.find(state.data.form.sections, function(s) {
				if (s.type === constants.section.type.nextstep) return false
				if (isPatient) return s.type === constants.section.type.patient
				return s.type === constants.section.type.standard
			})

			state.session.section.current = firstSection ? firstSection.id : 0

		},

		'session/validated': function(state, value) {

			state.session.validated = value

		},

		'session/profile': function(state, value) {

			state.session.profile = value

		},

		'session/values/named': function(state, data) {

			var named = _.findWhere(state.data.setup.variables, {
				reference: data.name
			})

			if(named) {

				state.session.values[named.id] = data.value

				console.log('session/values/override', data.name, state.session.values[named.id])
				
			}

		},

		'session/values/override': function(state, data) {

			state.session.values[data.id] = data.value

			console.log('session/values/override', data.id, state.session.values[data.id])

		},

		'session/values': function(state, data) {

			if (state.data.setup.variables[data.id].type === constants.logic.variable.type.set) {

				var set = state.session.values[data.id] || []

				if (_.contains(set, data.value)) {

					set.splice(set.indexOf(data.value), 1)

				} else {

					set.push(data.value)

				}

				state.session.values[data.id] = set

			} else {

				state.session.values[data.id] = data.value

			}

			console.log('session/values', data.id, state.session.values[data.id])

		},

		'session/values/all': function(state, data) {

			state.session.values = data

		},

		'session/inputs/flagged': function(state, value) {

			state.session.inputs.flagged.push(value)

		},

		'session/inputs/flagged/reset': function(state) {

			state.session.inputs.flagged = []

		},

		'session/alerts/current': function(state, value) {

			Vue.set(state.session.alerts, 'current', value)

		},

		'session/alerts/dynamic': function(state, data) {

			Vue.set(state.session.alerts, 'dynamic', data)

		},

		'session/alerts/completed': function(state, value) {

			if (!_.contains(state.session.alerts.completed, value)) state.session.alerts.completed.push(value)

		},

		'session/alerts/completed/reset': function(state) {

			state.session.alerts.completed = []

		},

		'session/section/current': function(state, value) {

			state.session.section.current = value

		},

		'session/section/completed': function(state, value) {

			if (!_.contains(state.session.section.completed, value)) state.session.section.completed.push(value)

		},

		'session/section/completed/reset': function(state, value) {

			state.session.section.completed = value

		},

		'session/section/dynamic': function(state, data) {

			state.session.section.dynamic = data

		},

		'session/recommendation': function(state, value) {

			state.session.recommendation = value

		},

		'session/aid': function(state, value) {

			state.session.aid = value

		},

		'session/finished': function(state, value) {

			state.session.finished = value

		},

		'session/bridge/active': function(state, value) {

			Vue.set(state.session.bridge, 'active', value)

		},

		'session/bridge/step': function(state, value) {

			Vue.set(state.session.bridge, 'step', value)

		},

		'session/bridge/question': function(state, value) {

			Vue.set(state.session.bridge, 'question', value)

		},

		'session/bridge/questions': function(state, value) {

			if (!_.contains(state.session.bridge.questions, value)) state.session.bridge.questions.push(value)

		},

		'session/bridge/code': function(state, value) {

			Vue.set(state.session.bridge, 'code', value)

		},

		'session/bridge/errors': function(state, value) {

			Vue.set(state.session.bridge, 'errors', value)

		},

		'session/bridge/completed': function(state, value) {

			if (!_.contains(state.session.bridge.completed, value)) state.session.bridge.completed.push(value)

		},

		'session/bridge/reset': function(state) {

			var completed = state.session.bridge.completed

			state.session.bridge = {
				active: null,
				step: null,
				question: 0,
				questions: [],
				code: null,
				errors: [],
				completed: completed
			}

		},

		'session/patient/mode': function(state, value) {

			Vue.set(state.session.patient, 'mode', value)

		},

		'session/patient/notes': function(state, value) {

			Vue.set(state.session.patient, 'notes', value)

		},

		'session/patient/goals': function(state, value) {

			Vue.set(state.session.patient, 'goals', value)

		},

		'data/set': function(state, value) {

			state.data = value

		}

	},

	actions: {

		set: function(context, e) {

			context.commit('session/values', {
				id: e.variable,
				value: e.value
			})

			var input = context.getters['data/form/inputs'][e.input]
			var defaultValue, defaultLogic, defaultCondition, copiedLogic

			_.each(context.getters['data/form/inputs'], function(input) {

				if (input.automated.enabled && input.default.enabled && context.getters['logic/visible'](input)) {

					var valueAssigned = false

					_.each(input.default.logic, function(logic) {
						
						copiedLogic = JSON.parse(JSON.stringify(logic))

						defaultCondition = _.keys(copiedLogic)[0]
						defaultLogic = copiedLogic[defaultCondition]
						defaultValue = defaultLogic.splice(defaultLogic.length - 1, 1)[0]

						if (context.getters['logic/evaluate']({
							[defaultCondition]: defaultLogic
						})) {

							context.commit('session/values', {
								id: input.variable,
								value: parseInt(defaultValue)
							})

							valueAssigned = true

						} 

					})

					if (!valueAssigned) {

						context.commit('session/values/override', {
							id: input.variable,
							value: null
						})

					}	

				}

			})

			if (context.getters['data/setup/track'].enabled && input.track.enabled && input.track.context === constants.track.context.input) {

				context.dispatch('track', {
					name: context.getters['data/setup/track'].name.input,
					params: {
						name: input.name,
						value: context.getters['logic/variable/friendly'](input.variable)
					}
				})

			}

		},
		
		proceed: function(context) {

			if (context.getters['session/recommendation']) {

				context.commit('session/section/current', context.getters['data/aid/sections/active'][0].id)
				context.commit('session/aid', true)

			} else {

				var track = []
				var invalidIndex = []

				context.commit('session/inputs/flagged/reset')

				// check any required fields missing
				_.each(context.getters['session/section/current/inputs'], function(input) {

					if (context.getters['logic/required'](input) && context.getters['session/values'][input.variable] === null) {

						context.commit('session/inputs/flagged', input.id)

					} else if (context.getters['logic/required'](input) && input.validation) {

						if (new RegExp(input.validation).test(context.getters['session/values'][input.variable]) === false) {

							invalidIndex.push(input.id)
							context.commit('session/inputs/flagged', input.id)

						}

					}

					if (context.getters['data/setup/track'].enabled && input.track.enabled && input.track.context === constants.track.context.section) {

						if (context.getters['logic/visible'](input)) {
							
							track.push({
								name: input.name,
								value: context.getters['logic/variable/friendly'](input.variable)
							})

						}

					}

				})

				// if some required inputs flagged, show alert and exit
				if (context.getters['session/inputs/flagged'].length) {

					var messages = []

					// build error list
					_.each(context.getters['session/inputs/flagged'], function(id) {

						messages.push(context.getters['data/form/inputs'][id].text[(_.contains(invalidIndex, id) ? 'invalid' : 'missing')])

					})

					// define alert
					context.commit('session/alerts/dynamic', {
						type: constants.alert.type.error,
						name: 'Error',
						message: '<p>The following errors must be corrected</p><ul><li>' + messages.join('</li><li>') + '</li></ul>',
						visibility: {
							enabled: constants.visibility.sometimes,
							logic: {}
						},
						inputs: [],
						buttons: {
							enabled: constants.visibility.always,
							logic: {},
							items: [{
								type: constants.button.type.review,
								variable: 0,
								text: 'Review',
								value: 0,
								visibility: {
									enabled: constants.visibility.always,
									logic: {}
								}
							}]
						}
					})

					context.commit('session/alerts/current', true)

					return false

				}
				
				context.commit('session/alerts/completed', context.getters['session/alerts/current'])
				context.commit('session/alerts/current', false)

				// check any alerts applicable
				_.each(context.getters['session/section/current/alerts'], function(alert) {

					if (!context.getters['session/alerts/current']) {

						if (context.getters['logic/visible'](alert) && !_.contains(context.getters['session/alerts/completed'], alert.id)) {

							context.commit('session/alerts/current', alert.id)

						}
						
					}

				})

				// if alert shown, exit 
				if (context.getters['session/alerts/current']) {

					return false

				}

				// find next section
				context.commit('session/section/completed', context.getters['session/section/current'])
				context.commit('session/section/current', false)

				var highestOrder = 0

				var isPatient = process.env.VUE_APP_MODE === 'patient'

				_.each(context.getters['data/form/sections'], function(section, index) {

					if(section.type === constants.section.type.nextstep) return
					if(!isPatient && section.type === constants.section.type.patient) return
					if(isPatient && section.type === constants.section.type.standard) return

					if(_.contains(context.getters['session/section/completed'], section.id)) {

						highestOrder = index

					}

				})

				_.each(context.getters['data/form/sections'], function(section, index) {

					if(section.type === constants.section.type.nextstep) return
					if(!isPatient && section.type === constants.section.type.patient) return
					if(isPatient && section.type === constants.section.type.standard) return

					if (!context.getters['session/section/current'] && index >= highestOrder) {

						if (context.getters['logic/required'](section) && !_.contains(context.getters['session/section/completed'], section.id)) {

							context.commit('session/section/current', section.id)

						}

					}

				})

				_.each(track, function(params) {

					context.dispatch('track', {
						name: context.getters['data/setup/track'].name.input,
						params: params
					})

				})

				// if section shown, exit 
				if (context.getters['session/section/current']) {

					return false

				}

				context.dispatch('finish')

			}

		},

		track: function(context, e) {

			// eslint-disable-next-line
			var log = (typeof(gtag) === 'undefined') ? console.log : gtag 

			log('event', e.params.name, {
				event_label: e.params.value,
				event_category: e.name
			})

		},

		finish: function(context) {

			// determine recommendation
			_.each(context.getters['data/decision/recommendations'], function(recommendation) {

				if (_.isObject(recommendation.logic)) {

					if (context.getters['logic/evaluate'](recommendation.logic)) {

						context.commit('session/recommendation', recommendation.id)

						console.log(recommendation)

						if (context.getters['data/setup/track'].enabled) {
							
							context.dispatch('track', {
								name: context.getters['data/setup/track'].name.recommendation,
								params: {
									name: recommendation.name
								}
							})

						}

					} 
					
				}

			})

			// define alert
			context.commit('session/section/dynamic', {
				id: true,
				icon: 5,
				text: {
					title: 'Recommendation'
				}
			})

			context.commit('session/section/current', true)

			context.commit('session/finished', true)

		},

		'bridge/proceed': function(context) {

			var nextstepSections = context.getters['data/form/sections/nextstep']

			context.commit('session/bridge/errors', [])
			context.commit('session/inputs/flagged/reset')

			if (!nextstepSections.length) {

				context.commit('session/bridge/step', 'complete')
				return

			}

			if (context.state.session.bridge.question) {

				var invalidIndex = []
				var section = context.getters['data/form/sections/nextstep/associated'][context.state.session.bridge.question]

				_.each(section.layout, function(layout) {

					if (layout.type !== constants.layout.type.text) {

						_.each(layout.inputs, function(inputId) {

							var input = context.getters['data/form/inputs'][inputId]

							if (!context.getters['logic/visible'](input)) return

							if (context.getters['logic/required'](input) && context.getters['session/values'][input.variable] === null) {

								context.commit('session/inputs/flagged', input.id)

							} else if (context.getters['logic/required'](input) && input.validation) {

								if (new RegExp(input.validation).test(context.getters['session/values'][input.variable]) === false) {

									invalidIndex.push(input.id)
									context.commit('session/inputs/flagged', input.id)

								}

							}

						})

					}

				})

				if (context.getters['session/inputs/flagged'].length) {

					var messages = []

					_.each(context.getters['session/inputs/flagged'], function(id) {

						var text = context.getters['data/form/inputs'][id].text
						messages.push(text[(_.contains(invalidIndex, id) ? 'invalid' : 'missing')] || 'This field is required')

					})

					context.commit('session/bridge/errors', messages)

					return false

				}

				context.commit('session/bridge/questions', context.state.session.bridge.question)

			}

			var nextSection = null

			_.each(nextstepSections, function(section) {

				if (!nextSection && context.getters['logic/required'](section) && !_.contains(context.state.session.bridge.questions, section.id)) {

					nextSection = section.id

				}

			})

			if (nextSection) {

				context.commit('session/bridge/question', nextSection)

			} else {

				context.commit('session/bridge/step', 'complete')

			}

		},

		review: function(context) {

			// go back to active pane and reset alerts
			context.commit('session/alerts/completed/reset')
			context.commit('session/alerts/current', false)
			context.commit('session/alerts/dynamic', false)

		},

		back: function(context, id) {

			context.commit('session/section/current', id)

			if (context.getters['session/aid']) return false
			
			context.commit('session/recommendation', false)
			context.commit('session/alerts/current', false)
			context.commit('session/alerts/dynamic', false)

			var oldCompleted = context.state.session.section.completed
			var newCompleted = []
			var section
			var backIndex = oldCompleted.indexOf(id)

			_.each(oldCompleted, function(id, index) {

				if (index < backIndex) {

					newCompleted.push(id)

				}
				
				if (index >= backIndex) {

					section = context.getters['data/form/sections/associated'][id]

					_.each(section.alerts, function(alert) {

						if (_.contains(context.state.session.alerts.completed, alert)) {

							context.state.session.alerts.completed.splice(context.state.session.alerts.completed.indexOf(alert), 1)

						}

						alert = context.getters['data/form/alerts'][alert]

						_.each(alert.buttons.items, function(button) {

							if (button.variable) {

								/*context.commit('session/values', {
									id: button.variable,
									value: null
								})*/

							}

						})

					})

					if (index > backIndex) {

						_.each(section.layout, function(layout) {

							if (layout.type !== constants.layout.type.text) {
			
								_.each(layout.inputs, function(input) {
			
									input = context.getters['data/form/inputs'][input]

									if (!input.automated.enabled) {

										context.commit('session/values', {
											id: input.variable,
											value: null
										})
				
									}
			
								})
			
							}
			
						})

					}

				}

			})

			context.commit('session/section/completed/reset', newCompleted)

			context.commit('session/finished', false)

		}

	}

})
